import React from "react";
import HandleCmdbeginner from "../Handle/HandleCmdbeginner";

function Cmdbeginner() {
  return <HandleCmdbeginner />;
}

export default Cmdbeginner;
